<template>
  <TooltipProvider>
    <Tooltip>
      <TooltipTrigger
        class="absolute right-0 top-0 h-full w-10 flex items-center justify-center text-muted-foreground"
        @click="$emit('click')"
      >
        <EyeOff v-if="passwordShown" :class="iconSize" stroke-width="1" />
        <Eye v-else :class="iconSize" stroke-width="1" />
      </TooltipTrigger>
      <TooltipContent side="right">
        {{ passwordShown ? 'Hide password' : 'Show password' }}
      </TooltipContent>
    </Tooltip>
  </TooltipProvider>
</template>

<script setup lang="ts">
import { Eye, EyeOff } from 'lucide-vue-next'

defineEmits(['click'])
const props = defineProps<{ passwordShown: boolean }>()

const iconSize = '!w-6 !h-6'
const shouldShowPassword = ref(false)

watch(
  () => props.passwordShown,
  newVal => {
    shouldShowPassword.value = newVal
  },
)
</script>
